import { Component, EventEmitter, Input, Output } from '@angular/core';

interface StatusChartItem {
  status: string;
  value: number;
  color: string;
}

interface TurnaroundStats {
  user: number;
  team: number;
}

interface GroupAnalyticsRow {
  name: string;
  completed: number;
  inProgress: number;
  avgTurnaround: number;
  activeRequests: number;
}

@Component({
    selector: 'app-analytics',
    templateUrl: './analytics.component.html',
    styleUrls: ['./analytics.component.css'],
    standalone: false
})
export class AnalyticsComponent {
  @Input() timeRanges: string[] = [];
  @Input() selectedTimeRange = '';
  @Input() chartCategories: string[] = [];
  @Input() userPerformanceData: number[] = [];
  @Input() teamPerformanceData: number[] = [];
  @Input() statusChartData: StatusChartItem[] = [];
  @Input() avgTurnaroundDays!: TurnaroundStats;
  @Input() isAdmin = false;
  @Input() groupAnalytics: GroupAnalyticsRow[] = [];

  @Output() timeRangeChange = new EventEmitter<string>();

  onTimeRangeChange(value: string): void {
    this.selectedTimeRange = value;
    this.timeRangeChange.emit(value);
  }
}
